import styled from 'styled-components';
import { Button } from '../../atoms/Button';

export const StyledActionButton = styled(Button)`
  text-align: left;
  padding: 0;
  border: 0;
  margin: 0;
  background: transparent;

  &:hover {
    text-decoration: underline;
  }
`;
